<div
  class="accordion-item accordion-item--faq accordion-item--large accordion-item--silver-border js-accordion-item"
  [ngClass]="{ 'accordion-item--active': open }"
>
  <div class="accordion-item-header accordion-item-header--icon-right js-accordion-item-header" (click)="toggle()">
    {{ title }}

    <div class="accordion-item-header-plus">
      <div></div>
      <div></div>
    </div>
  </div>

  <div class="accordion-item-content accordion-item-content--no-side-padding js-accordion-item-content" style="display: none">
    <div class="default-text-spacing">
      <div class="default-text">
        <markdown [data]="content"></markdown>
      </div>
    </div>
  </div>
</div>
